import { ReactElement } from "react"
import { Route, Routes } from "react-router-dom"

import RequireRoles from "./requireRoles"
import * as routes from "./routes"
import Login from "../aws/login"
import RequireAuth from "../aws/requireAuth"
import PageNotFound from "../components/fallback/pageNotFound"
import SignOutSuccess from "../components/fallback/signOutSuccess"
import AmendSingleApplication from "../components/submitApplication/amend/amendSingleApplication"
import NewSingleApplication from "../components/submitApplication/single/newSingleApplication"
import {
    DNO_ADMIN,
    DNO_REVIEWER,
    ENA_SYS_ADMIN,
    INSTALLER_ADMIN,
    LCT_MANU_APPROVED,
    PUBLIC,
    CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY,
    DB_ASSESSOR_DEMAND,
    LCT_MANU_ADMIN,
    DNO_APPROVED,
    DB_ASSESSOR_GEN,
    DB_ASSESSOR_V2G,
    INSIGHTS_AUTHOR,
    INSIGHTS_READER,
} from "../constants/roles"
import AdminPortal from "../webpages/adminPortal/adminPortal"
import Changelog from "../webpages/changelog/changelog"
import SubmitCommissioning from "../webpages/commissioning/submitCommissioning"
import CompanySearch from "../webpages/companyLookup/companySearch"
import DeveloperPortal from "../webpages/developer/developerPortal"
import AmendAcuDevice from "../webpages/devices/lct/amendAcuDevice/amendAcuDevice"
import AmendEbDevice from "../webpages/devices/lct/amendEbDevice/amendEbDevice"
import AmendEVACDevice from "../webpages/devices/lct/amendEVACDevice/amendEVACDevice"
import AmendEVDCDevice from "../webpages/devices/lct/amendEVDCDevice/amendEVDCDevice"
import AmendHpDevice from "../webpages/devices/lct/amendHpDevice/amendHpDevice"
import ContinueAcuDraftDeviceAmendment from "../webpages/devices/lct/continueAcuDraftDeviceAmendment/continueAcuDraftDeviceAmendment"
import ContinueAcuDraftDeviceVersion from "../webpages/devices/lct/continueAcuDraftDeviceVersion/continueAcuDraftDeviceVersion"
import ContinueEbDraftDeviceAmendment from "../webpages/devices/lct/continueEbDraftDeviceAmendment/continueEbDraftDeviceAmendment"
import ContinueEbDraftDeviceVersion from "../webpages/devices/lct/continueEbDraftDeviceVersion/continueEbDraftDeviceVersion"
import ContinueEVACDraftDeviceAmendment from "../webpages/devices/lct/continueEVACDraftDeviceAmendment/continueEVACDraftDeviceAmendment"
import ContinueEVACDraftDeviceVersion from "../webpages/devices/lct/continueEVACDraftDeviceVersion/continueEVACDraftDeviceVersion"
import ContinueEVDCDraftDeviceAmendment from "../webpages/devices/lct/continueEVDCDraftDeviceAmendment/continueEVDCDraftDeviceAmendment"
import ContinueEVDCDraftDeviceVersion from "../webpages/devices/lct/continueEVDCDraftDeviceVersion/continueEVDCDraftDeviceVersion"
import ContinueHpDraftDeviceAmendment from "../webpages/devices/lct/continueHpDraftDeviceAmendment/continueHpDraftDeviceAmendment"
import ContinueHpDraftDeviceVersion from "../webpages/devices/lct/continueHpDraftDeviceVersion/continueHpDraftDeviceVersion"
import NewAcuDeviceVersion from "../webpages/devices/lct/newAcuDeviceVersion/newAcuDeviceVersion"
import NewEbDeviceVersion from "../webpages/devices/lct/newEbDeviceVersion/newEbDeviceVersion"
import NewEVACDeviceVersion from "../webpages/devices/lct/newEVACDeviceVersion/newEVACDeviceVersion"
import NewEVDCDeviceVersion from "../webpages/devices/lct/newEVDCDeviceVersion/newEVDCDeviceVersion"
import NewHpDeviceVersion from "../webpages/devices/lct/newHpDeviceVersion/newHpDeviceVersion"
import PublishAcuDevice from "../webpages/devices/lct/publishAcuDevice/publishAcuDevice"
import PublishEbDevice from "../webpages/devices/lct/publishEbDevice/publishEbDevice"
import PublishEVACDevice from "../webpages/devices/lct/publishEVACDevice/publishEVACDevice"
import PublishEVDCDevice from "../webpages/devices/lct/publishEVDCDevice/publishEVDCDevice"
import PublishHpDevice from "../webpages/devices/lct/publishHpDevice/publishHpDevice"
import PublishV2GBundleDevice from "../webpages/devices/lct/publishV2GBundleDevice/publishV2GBundleDevice"
import SelectDeviceToPublish from "../webpages/devices/selectDeviceToPublish"
import AmendDevice from "../webpages/devices/ttr/amendDevice/amendDevice"
import ContinueDraftDeviceAmendment from "../webpages/devices/ttr/continueDraftDeviceAmendment/continueDraftDeviceAmendment"
import ContinueDraftDeviceVersion from "../webpages/devices/ttr/continueDraftDeviceVersion/continueDraftDeviceVersion"
import NewDeviceVersion from "../webpages/devices/ttr/newDeviceVersion/newDeviceVersion"
import PublishDevice from "../webpages/devices/ttr/publishDevice/publishDevice"
import DnoSingleApplication from "../webpages/dnoPortal/dnoSingleApplication"
import ListApplications from "../webpages/dnoPortal/listApplications"
import ListNotifications from "../webpages/dnoPortal/listNotifications"
// import ListApplicationsAwaitingReview from "../webpages/dnoPortal/listApplicationsAwaitingReview"
import ThresholdManagement from "../webpages/dnoPortal/thresholdManagement/thresholdManagement"
import Homepage from "../webpages/homepage/homepage"
import InsightsEmbeddedContainer from "../webpages/insights/insights"
import InstallerListApplications from "../webpages/installerPortal/installerListApplications"
import InstallerListDrafts from "../webpages/installerPortal/installerListDrafts"
import InstallerSingleApplication from "../webpages/installerPortal/installerSingleApplication"
import LearnMore from "../webpages/learnMore/learnMore"
import AssessDemandDevice from "../webpages/lowCarbonTechDatabases/assessDemandDevice"
import DemandDeviceSearch from "../webpages/lowCarbonTechDatabases/demandDeviceSearch"
import GenDeviceSearch from "../webpages/lowCarbonTechDatabases/genDeviceSearch"
import SingleDemandDevice from "../webpages/lowCarbonTechDatabases/singleDemandDevice"
import SingleDemandDeviceDraft from "../webpages/lowCarbonTechDatabases/singleDemandDeviceDraft"
import SingleGenDevice from "../webpages/lowCarbonTechDatabases/singleGenDevice"
import SingleGenDeviceDraft from "../webpages/lowCarbonTechDatabases/singleGenDeviceDraft"
import MyOrganisation from "../webpages/organisation/myOrganisation"
import { COOKIE_POLICY_CONTENT } from "../webpages/privacyPage/cookiePolicy"
import PolicyBuilder from "../webpages/privacyPage/policyBuilder"
import { PRIVACY_POLICY } from "../webpages/privacyPage/privacyPolicy"
import { TERMS_OF_USE_CONTENT } from "../webpages/privacyPage/termsOfUse"

type RouteConfigProtected = {
    path: string
    element: ReactElement
    protected: true
    permittedRoles: string[]
}

type RouteConfigPublic = {
    path: string
    element: ReactElement
    protected: false
    permittedRoles: ["PUBLIC"]
}

/* Defines all routes in the application and their associated permissions.
A protected route `protected: true` requires authentication. These routes
are passed through the amplify authentication provider, which forces an
unauthenticated user to log-in before progressing. Permitted-roles defines
1) the roles that can access a route and 2) whether or not a user can see
a route on the navigation bar. Unprotected routes should be tagged as public.
All protected routes should have an associated list of approved roles  */

export const routeConfig: Record<
    string,
    RouteConfigProtected | RouteConfigPublic
> = {
    [routes.BASE_URL]: {
        path: routes.BASE_URL,
        element: <Homepage />,
        protected: false,
        permittedRoles: [PUBLIC],
    },

    [routes.GEN_DEVICE_SEARCH]: {
        path: routes.GEN_DEVICE_SEARCH,
        element: <GenDeviceSearch />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.DEMAND_DEVICE_SEARCH]: {
        path: routes.DEMAND_DEVICE_SEARCH,
        element: <DemandDeviceSearch />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.SINGLE_GEN_DEVICE]: {
        path: routes.SINGLE_GEN_DEVICE,
        element: <SingleGenDevice />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.SINGLE_GEN_DEVICE_DRAFT]: {
        path: routes.SINGLE_GEN_DEVICE_DRAFT,
        element: <SingleGenDeviceDraft />,
        protected: true,
        permittedRoles: [LCT_MANU_APPROVED, ENA_SYS_ADMIN],
    },
    [routes.SINGLE_DEMAND_DEVICE]: {
        path: routes.SINGLE_DEMAND_DEVICE,
        element: <SingleDemandDevice />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.SINGLE_DEMAND_DEVICE_DRAFT]: {
        path: routes.SINGLE_DEMAND_DEVICE_DRAFT,
        element: <SingleDemandDeviceDraft />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.NOT_FOUND_ROUTE]: {
        path: routes.NOT_FOUND_ROUTE,
        element: <PageNotFound />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.LOGIN]: {
        path: routes.LOGIN,
        element: <Login />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.RESET_PASSWORD]: {
        path: routes.RESET_PASSWORD,
        element: <Login initialState="forgotPassword" />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.SIGN_OUT_SUCCESS]: {
        path: routes.SIGN_OUT_SUCCESS,
        element: <SignOutSuccess />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.ADMIN_PORTAL]: {
        path: routes.ADMIN_PORTAL,
        element: <AdminPortal />,
        protected: true,
        permittedRoles: [
            ENA_SYS_ADMIN,
            DNO_ADMIN,
            INSTALLER_ADMIN,
            LCT_MANU_ADMIN,
        ],
    },
    [routes.PRIVACY_POLICY]: {
        path: routes.PRIVACY_POLICY,
        element: (
            <PolicyBuilder
                title="ENA Connect Direct Privacy Policy"
                body={PRIVACY_POLICY}
            />
        ),
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.TERMS_OF_USE]: {
        path: routes.TERMS_OF_USE,
        element: (
            <PolicyBuilder
                title="ENA Connect Direct Terms of Use"
                body={TERMS_OF_USE_CONTENT}
            />
        ),
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.COOKIE_POLICY]: {
        path: routes.COOKIE_POLICY,
        element: (
            <PolicyBuilder
                title="ENA Connect Direct Cookie Policy"
                body={COOKIE_POLICY_CONTENT}
            />
        ),
        protected: false,
        permittedRoles: [PUBLIC],
    },

    [routes.CHANGE_LOG]: {
        path: routes.CHANGE_LOG,
        element: <Changelog />,
        protected: true,
        permittedRoles: [
            DNO_APPROVED,
            LCT_MANU_APPROVED,
            CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY,
            ENA_SYS_ADMIN,
            DB_ASSESSOR_DEMAND,
            DB_ASSESSOR_GEN,
            DB_ASSESSOR_V2G,
        ],
    },

    [routes.DNO_APPLICATIONS_NOTIFICATIONS]: {
        path: routes.DNO_APPLICATIONS_NOTIFICATIONS,
        element: <ListApplications />,
        protected: true,
        permittedRoles: [DNO_REVIEWER],
    },
    [routes.DNO_SOLAR_NOTIFICATIONS]: {
        path: routes.DNO_SOLAR_NOTIFICATIONS,
        element: <ListNotifications />,
        protected: true,
        permittedRoles: [DNO_REVIEWER],
    },
    [routes.DNO_APPLICATIONS_ESCALATIONS]: {
        path: routes.DNO_APPLICATIONS_ESCALATIONS,
        element: <ListApplications />,
        protected: true,
        permittedRoles: [DNO_REVIEWER],
    },
    [routes.DNO_APPLICATIONS_WORKS_REQUIRED]: {
        path: routes.DNO_APPLICATIONS_WORKS_REQUIRED,
        element: <ListApplications />,
        protected: true,
        permittedRoles: [DNO_REVIEWER],
    },
    [routes.DNO_SINGLE_APPLICATION]: {
        path: routes.DNO_SINGLE_APPLICATION,
        element: <DnoSingleApplication />,
        protected: true,
        permittedRoles: [DNO_REVIEWER],
    },
    [routes.DNO_THRESHOLD_MANAGEMENT]: {
        path: routes.DNO_THRESHOLD_MANAGEMENT,
        element: <ThresholdManagement />,
        protected: true,
        permittedRoles: [DNO_APPROVED],
    },
    [routes.DEV_PORTAL]: {
        path: routes.DEV_PORTAL,
        element: <DeveloperPortal />,
        protected: true,
        permittedRoles: [INSTALLER_ADMIN, DNO_ADMIN, ENA_SYS_ADMIN],
    },
    [routes.NEW_SINGLE_APPLICATION]: {
        path: routes.NEW_SINGLE_APPLICATION,
        element: <NewSingleApplication />,
        protected: true,
        permittedRoles: [CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY],
    },
    [routes.AMEND_SINGLE_APPLICATION]: {
        path: routes.AMEND_SINGLE_APPLICATION,
        element: <AmendSingleApplication />,
        protected: true,
        permittedRoles: [CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY],
    },
    [routes.INSTALLER_SINGLE_APPLICATION]: {
        path: routes.INSTALLER_SINGLE_APPLICATION,
        element: <InstallerSingleApplication />,
        protected: true,
        permittedRoles: [CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY],
    },
    [routes.INSTALLER_LIST_APPLICATIONS]: {
        path: routes.INSTALLER_LIST_APPLICATIONS,
        element: <InstallerListApplications />,
        protected: true,
        permittedRoles: [CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY],
    },
    [routes.INSTALLER_DRAFTS]: {
        path: routes.INSTALLER_DRAFTS,
        element: <InstallerListDrafts />,
        protected: true,
        permittedRoles: [CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY],
    },
    [routes.COMMISSIONING_FORM]: {
        path: routes.COMMISSIONING_FORM,
        element: <SubmitCommissioning />,
        protected: true,
        permittedRoles: [CONFIG_RULE_SOLE_TRADERS_OR_APPROVED_INSTALLER_ONLY],
    },
    [routes.TTR_PUBLISH_DEVICE]: {
        path: routes.TTR_PUBLISH_DEVICE,
        element: <PublishDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.TTR_AMEND_DEVICE]: {
        path: routes.TTR_AMEND_DEVICE,
        element: <AmendDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.TTR_NEW_VERSION]: {
        path: routes.TTR_NEW_VERSION,
        element: <NewDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.TTR_CONTINUE_DEVICE_AMENDMENT_DRAFT]: {
        path: routes.TTR_CONTINUE_DEVICE_AMENDMENT_DRAFT,
        element: <ContinueDraftDeviceAmendment />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.TTR_CONTINUE_DEVICE_VERSION_DRAFT]: {
        path: routes.TTR_CONTINUE_DEVICE_VERSION_DRAFT,
        element: <ContinueDraftDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVAC_PUBLISH_DEVICE]: {
        path: routes.EVAC_PUBLISH_DEVICE,
        element: <PublishEVACDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.V2G_BUNDLE_PUBLISH_DEVICE]: {
        path: routes.V2G_BUNDLE_PUBLISH_DEVICE,
        element: <PublishV2GBundleDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVDC_PUBLISH_DEVICE]: {
        path: routes.EVDC_PUBLISH_DEVICE,
        element: <PublishEVDCDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.HP_PUBLISH_DEVICE]: {
        path: routes.HP_PUBLISH_DEVICE,
        element: <PublishHpDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EB_PUBLISH_DEVICE]: {
        path: routes.EB_PUBLISH_DEVICE,
        element: <PublishEbDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EB_CONTINUE_DEVICE_VERSION_DRAFT]: {
        path: routes.EB_CONTINUE_DEVICE_VERSION_DRAFT,
        element: <ContinueEbDraftDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EB_AMEND_DEVICE]: {
        path: routes.EB_AMEND_DEVICE,
        element: <AmendEbDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EB_NEW_VERSION]: {
        path: routes.EB_NEW_VERSION,
        element: <NewEbDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EB_CONTINUE_DEVICE_AMENDMENT_DRAFT]: {
        path: routes.EB_CONTINUE_DEVICE_AMENDMENT_DRAFT,
        element: <ContinueEbDraftDeviceAmendment />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.ACU_PUBLISH_DEVICE]: {
        path: routes.ACU_PUBLISH_DEVICE,
        element: <PublishAcuDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.ACU_CONTINUE_DEVICE_VERSION_DRAFT]: {
        path: routes.ACU_CONTINUE_DEVICE_VERSION_DRAFT,
        element: <ContinueAcuDraftDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.ACU_AMEND_DEVICE]: {
        path: routes.ACU_AMEND_DEVICE,
        element: <AmendAcuDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.ACU_NEW_VERSION]: {
        path: routes.ACU_NEW_VERSION,
        element: <NewAcuDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.ACU_CONTINUE_DEVICE_AMENDMENT_DRAFT]: {
        path: routes.ACU_CONTINUE_DEVICE_AMENDMENT_DRAFT,
        element: <ContinueAcuDraftDeviceAmendment />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.ASSESS_DEMAND_DEVICE]: {
        path: routes.ASSESS_DEMAND_DEVICE,
        element: <AssessDemandDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, DB_ASSESSOR_DEMAND],
    },
    [routes.EVAC_AMEND_DEVICE]: {
        path: routes.EVAC_AMEND_DEVICE,
        element: <AmendEVACDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.PUBLISH_NEW_LCT_TTR_DEVICE]: {
        path: routes.PUBLISH_NEW_LCT_TTR_DEVICE,
        element: <SelectDeviceToPublish />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVAC_CONTINUE_DEVICE_AMENDMENT_DRAFT]: {
        path: routes.EVAC_CONTINUE_DEVICE_AMENDMENT_DRAFT,
        element: <ContinueEVACDraftDeviceAmendment />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVDC_CONTINUE_DEVICE_AMENDMENT_DRAFT]: {
        path: routes.EVDC_CONTINUE_DEVICE_AMENDMENT_DRAFT,
        element: <ContinueEVDCDraftDeviceAmendment />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVDC_AMEND_DEVICE]: {
        path: routes.EVDC_AMEND_DEVICE,
        element: <AmendEVDCDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.HP_AMEND_DEVICE]: {
        path: routes.HP_AMEND_DEVICE,
        element: <AmendHpDevice />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVAC_CONTINUE_DEVICE_VERSION_DRAFT]: {
        path: routes.EVAC_CONTINUE_DEVICE_VERSION_DRAFT,
        element: <ContinueEVACDraftDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVDC_CONTINUE_DEVICE_VERSION_DRAFT]: {
        path: routes.EVDC_CONTINUE_DEVICE_VERSION_DRAFT,
        element: <ContinueEVDCDraftDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.LEARN_MORE]: {
        path: routes.LEARN_MORE,
        element: <LearnMore />,
        protected: false,
        permittedRoles: [PUBLIC],
    },
    [routes.EVAC_NEW_VERSION]: {
        path: routes.EVAC_NEW_VERSION,
        element: <NewEVACDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.EVDC_NEW_VERSION]: {
        path: routes.EVDC_NEW_VERSION,
        element: <NewEVDCDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.HP_CONTINUE_DEVICE_VERSION_DRAFT]: {
        path: routes.HP_CONTINUE_DEVICE_VERSION_DRAFT,
        element: <ContinueHpDraftDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.HP_CONTINUE_DEVICE_AMENDMENT_DRAFT]: {
        path: routes.HP_CONTINUE_DEVICE_AMENDMENT_DRAFT,
        element: <ContinueHpDraftDeviceAmendment />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.HP_NEW_VERSION]: {
        path: routes.HP_NEW_VERSION,
        element: <NewHpDeviceVersion />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, LCT_MANU_APPROVED],
    },
    [routes.COMPANY_SEARCH]: {
        path: routes.COMPANY_SEARCH,
        element: <CompanySearch />,
        protected: true,
        permittedRoles: [ENA_SYS_ADMIN, DNO_APPROVED],
    },
    [routes.ADMIN_MY_ORGANISATION]: {
        path: routes.ADMIN_MY_ORGANISATION,
        element: <MyOrganisation />,
        protected: true,
        permittedRoles: [LCT_MANU_ADMIN, INSTALLER_ADMIN],
    },
    [routes.INSIGHTS]: {
        path: routes.INSIGHTS,
        element: <InsightsEmbeddedContainer />,
        protected: true,
        permittedRoles: [INSIGHTS_AUTHOR, INSIGHTS_READER],
    },
}

/**
 * Compiles `router` object into the application's router.
 * Imported and used once at `<App>` level. Each route is defined in `config`,
 * based on the type `RouteConfig`. This includes a flag for if the route
 * should be placed behind an authentication check. Protected routes are
 * wrapped in `RequireAuth` which necessitates authentication.
 *
 * This does not include a `BrowserRouter` which is included in `index.tsx`.
 * This is because some components higher in component tree require access to
 * react router hooks
 *
 * @example
 * <RouterProvider />
 */
const AppRouter = (): ReactElement => (
    <Routes>
        {Object.keys(routeConfig).map((key: string) => {
            const route: RouteConfigProtected | RouteConfigPublic =
                routeConfig[key]
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        route.protected ? (
                            <RequireAuth>
                                <RequireRoles
                                    requiredRoles={route.permittedRoles}
                                >
                                    {route.element}
                                </RequireRoles>
                            </RequireAuth>
                        ) : (
                            route.element
                        )
                    }
                />
            )
        })}
    </Routes>
)

export default AppRouter
